import { Option } from '@mailstep/design-system/ui/Elements/Select/types'
import { Eshop, EshopApi } from '@typings/entities/Eshop'
import toSelectOption from './toSelectOption'

const getEshopOptions = (eshops?: (Eshop | EshopApi)[]): Option<string>[] => (eshops || []).map(toSelectOption('id', 'name'))

export default getEshopOptions
